module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1284.a322ad21.png";